import Text from '@passkeys/ui/text';

import type { Asset } from '@/types';
import Loading from './loading.js';
import TokenList from './token-list.js';

export interface SearchedTokensProps {
  tokens: Asset[];
  loading: boolean;
}

function SearchedTokens({ tokens, loading }: SearchedTokensProps) {
  return loading ? (
    <Loading />
  ) : tokens.length === 0 ? (
    <Text
      align="center"
      size={13}
      className="mt-8 text-black/50 theme-dark:text-white/50"
    >
      No results found.
    </Text>
  ) : (
    <TokenList tokens={tokens} />
  );
}

export default SearchedTokens;
